export const getHelperText = (propertyDescription: string | null, errorMessage: string | null): string | null =>
    (propertyDescription !== null && errorMessage === null ? propertyDescription : errorMessage);

export const getHelperTextType = (errorMessage: string | null): 'error' | 'info' =>
    (errorMessage !== null ? 'error' : 'info');